import { configPublic } from '@src/config.public'
import { STORAGE } from '@src/utils/constants.util'

const storageNamespace = 'commerceWeb:'

/**
 * Centralized access to stored values
 * in LocalStorage and/or SessionStorage.
 **/
export const storage = {
  local: {
    get: getStoredValueFactory(globalThis?.localStorage),
    set: setStoredValueFactory(globalThis?.localStorage),
    remove: removeStoredValueFactory(globalThis?.localStorage),
  },
  session: {
    get: getStoredValueFactory(globalThis?.sessionStorage),
    set: setStoredValueFactory(globalThis?.sessionStorage),
    remove: removeStoredValueFactory(globalThis?.sessionStorage),
  },
}

/** Keys that are allowed to be stored by the app. */
export type StoredValueKey = keyof typeof defaultValues

const defaultValues = {
  [STORAGE.logsVisibleInConsole]: configPublic.logs.logsVisibleInConsole,
  [STORAGE.logLevelClient]: null,
  [STORAGE.lastActivityTimestamp]: null,
  [STORAGE.sseOrders]: [],
}

function getStoredValueFactory(storage: Storage) {
  return function getStoredValue(key: StoredValueKey) {
    if (!storage) return
    const serializedValue = storage[`${storageNamespace}${key}`]
    return serializedValue ? JSON.parse(serializedValue) : defaultValues[key]
  }
}

function setStoredValueFactory(storage: Storage) {
  return function setStoredValue(key: StoredValueKey, value: unknown) {
    if (value === undefined || !storage) return
    const serializedValue = JSON.stringify(value) || JSON.stringify(defaultValues[key])
    storage[`${storageNamespace}${key}`] = serializedValue
  }
}

function removeStoredValueFactory(storage: Storage) {
  return function removeStoredValue(key: StoredValueKey) {
    if (!storage) return
    storage?.removeItem?.(`${storageNamespace}${key}`)
  }
}
